/**
 * `/portal` — where every portal login lands (the enrolment screen sends
 * everyone here). An operator login goes on to its Assignments, a
 * dispatcher to the office board; a driver login gets the driver's day
 * (`driverHome`), exactly as before.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { PORTAL_USER_KINDS } from '../../../config/config';
import usePortalPrincipal from './usePortalPrincipal';

export default function PortalLanding({ driverHome }) {
  const { kind, loading } = usePortalPrincipal();

  if (loading) return <div className="pp-state" role="status">…</div>;

  if (kind === PORTAL_USER_KINDS.OPERATOR) return <Navigate to="/portal/operator" replace />;
  if (kind === PORTAL_USER_KINDS.DISPATCHER) return <Navigate to="/portal/dispatcher" replace />;

  // A driver — or a session whose kind couldn't be looked up, which the
  // driver's day already handles (its own session call and error screen).
  return driverHome;
}
